import { lightTheme } from '@/customTheme'

interface Props {
  src: string
  alt?: string
}

function ModalImagePanel({ src, alt }: Props) {
  return (
    <div
      style={{
        width: '50%',
        position: 'relative',
        background: lightTheme.colors.grayScale50,
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
    </div>
  )
}

export default ModalImagePanel
